import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/moneyout-general-types/moneyout/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchMoneyOutTenantsNoSuspense =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useQuery
